<template>
     <div>
      <h1>{{ $t('help.ISAInsightRoomFallRate_title') }}</h1>
      <p class="text-justify">
          {{ $t('The fall rate is the average period between each fall.') }}
      </p>
      
    </div>
</template>

<script>

export default  {
  components: {    
  },  
  data() {
    return {      
    }
  },
  watch : {    
  },    
  methods: {        
    },
  mounted() {            
  },
  name: "ISAHelpModalContent"
}
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 700;
}

.modal-title {
  font-weight: 700;
}

</style>
